var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-tabs"},_vm._l((_vm.navigations),function(item,index){return _c('a',{key:`menu-tab-item-${index}`,class:[
      'tab-item',
      { active: item.routes.includes(_vm.activeTab) },
      { 'border-first': item.first },
      { 'border-last': item.last }
    ],on:{"click":function($event){return _vm.goto(item)}}},[_c('i',{class:[
        'icon',
        item.icon,
        item.routes.includes(_vm.activeTab) ? 'color-item-white' : ''
      ],staticStyle:{"color":"#ff00007a"}}),_c('span',{staticClass:"lg:hidden"},[_vm._v(_vm._s(item.labelDesktop))]),_c('span',{staticClass:"hidden lg:block"},[_vm._v(_vm._s(item.labelMobile))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }